import React from "react";
import "./style.css";

const MainLayout = ({ children }) => {
  return <div className="prime-layout">{children}</div>;
};

export default MainLayout;
